// The tabs of /agents. The chosen tab is the URL's `tab` search value: the word `activity` (the owner's stream) or nothing.
export type Tab = 'proposals' | 'activity'

export function parseSearch(search: Record<string, unknown>): { tab?: 'activity' } {
  return search.tab === 'activity' ? { tab: 'activity' } : {}
}
